import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import {
  StatusBeketPurchaseTypes,
  StatusPurchase,
  StatusPurchaseExcursion,
  StatusPurchaseExcursionTypes,
  StatusStatusPurchaseTypes,
} from 'shared/constants'

import s from './styles.module.scss'

interface Props {
  status?:
    | StatusStatusPurchaseTypes
    | StatusPurchaseExcursionTypes
    | StatusBeketPurchaseTypes
  isExcursion?: boolean
}

export const StatusBought: FC<Props> = ({ status, isExcursion }) => {
  const { t } = useTranslation()

  if (!status) return null

  const { color, background, name } = isExcursion
    ? StatusPurchaseExcursion[status as StatusPurchaseExcursionTypes]
    : StatusPurchase[status]

  return (
    <div
      className={clsx(s.container, 'medium-12')}
      style={{ backgroundColor: background, color }}
    >
      {t(name)}
    </div>
  )
}
